import { DotsLoaderComponent } from '@myre/ui-primitive-components';
import {
  FormComponent,
  QuestionControlService,
  type ElementBase,
} from '@myre/ui-primitive-forms';

import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  Input,
  output,
  signal,
} from '@angular/core';
import { type UntypedFormGroup } from '@angular/forms';
import { castArray } from 'lodash-es';

@Component({
  selector: 'myre-form-cell',
  templateUrl: './form-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DotsLoaderComponent, FormComponent],
})
export class FormCellComponent {
  @Input({ required: true })
  public set element(element: ElementBase | null) {
    if (!element) {
      return;
    }
    const elements = castArray(element);

    this._form.set(this._questionControlService.generateForm(elements));
    this._elements.set(elements);
  }

  public readonly form = output<UntypedFormGroup>();

  protected readonly _form = signal<UntypedFormGroup | null>(null);
  protected readonly _elements = signal<ElementBase[]>([]);

  private readonly _questionControlService = inject(QuestionControlService);

  constructor() {
    effect(() => {
      if (!this._form()) {
        return;
      }

      this.form.emit(this._form());
    });
  }
}
